import { baseAPI } from "../../../baseApi";
import { tagsTypes } from "../../../tagsTypes";

export const productInfoSlice = baseAPI.injectEndpoints({
  endpoints: (builder) => ({
    // Save product basic information
    postProductBasicInfo: builder.mutation({
      query: ({data, lang}) => ({
        url: `product-title-overview/${lang}`,
        method: "POST",
        body: data,
      }),
      invalidatesTags: [
        tagsTypes.GET_PRODUCT_DETAIL,
        tagsTypes.GET_PRODUCT_LIST,
      ],
    }),

    // Get product categories
    getProductCategories: builder.query({
      query: () => ({
        url: "products-categories",
        method: "GET",
      }),
    }),

    // Save product category data
    postProductCategoriesInfo: builder.mutation({
      query: (data) => ({
        url: "product-categories-save",
        method: "POST",
        body: data,
      }),
      invalidatesTags: [tagsTypes.GET_PRODUCT_DETAIL],
    }),

    // Save product pictures
    postProductPictures: builder.mutation({
      query: (data) => ({
        url: "product-pictures-save",
        method: "POST",
        body: data,
      }),
      invalidatesTags: [tagsTypes.GET_PRODUCT_DETAIL],
    }),

    // Remove product pictures
    removeProductPictures: builder.mutation({
      query: (data) => ({
        url: "product-pictures-remove",
        method: "POST",
        body: data,
      }),
      invalidatesTags: [tagsTypes.GET_PRODUCT_DETAIL],
    }),

    // Update product pictures
    updatePictureTitle: builder.mutation({
      query: (data) => ({
        url: "product-picture-title-update",
        method: "POST",
        body: data,
      }),
      invalidatesTags: [tagsTypes.GET_PRODUCT_DETAIL],
    }),

    // Update cover image
    updateCoverPicture: builder.mutation({
      query: (data) => ({
        url: "product-picture-ordering-cover-update",
        method: "POST",
        body: data,
      }),
      invalidatesTags: [tagsTypes.GET_PRODUCT_DETAIL],
    }),
  }),
});

export const {
  usePostProductBasicInfoMutation,
  useGetProductCategoriesQuery,
  usePostProductCategoriesInfoMutation,
  usePostProductPicturesMutation,
  useRemoveProductPicturesMutation,
  useUpdatePictureTitleMutation,
  useUpdateCoverPictureMutation,
} = productInfoSlice;
